'use client';

import * as SwitchPrimitives from '@radix-ui/react-switch';
import {ComponentPropsWithoutRef, ElementRef, forwardRef} from 'react';
import {cn} from '../../libs';

export const Switch = forwardRef<
  ElementRef<typeof SwitchPrimitives.Root>,
  ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({...rest}, ref) => (
  <SwitchPrimitives.Root
    {...rest}
    ref={ref}
    className={cn(
      'peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-[transparent] transition-colors',
      'data-[state=checked]:bg-brand-secondary',
      'data-[state=unchecked]:bg-bg-muted',
      'disabled:cursor-not-allowed',
      'disabled:opacity-50',
      rest.className,
    )}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        'pointer-events-none block size-5 rounded-full bg-bg-secondary transition-transform',
        'data-[state=checked]:translate-x-5',
        'data-[state=unchecked]:translate-x-0',
      )}
    />
  </SwitchPrimitives.Root>
));

Switch.displayName = SwitchPrimitives.Root.displayName;
